export default {
    NEVER: 'never',
    UNKNOWN: 'unknown',
};
